module.exports = __webpack_public_path__ + "img/2_14_1.dcc673a8.jpg";